const PREFIX = '[snapshot]';
export const logger = {
    info: (...args) => console.info(PREFIX, ...args),
    warn: (...args) => console.warn(PREFIX, ...args),
    error: (...args) => console.error(PREFIX, ...args),
};
//# sourceMappingURL=logger.js.map